import { useRef, useEffect } from 'react';

interface UsePrevious {
	(value: any): any;
}

export const usePrevious: UsePrevious = (value) => {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
};
